{{events | json}}
{{ '::EventTicketAdmin:DeveloperName' | abpLocalization }}